import React from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {MultipleSelector, SetUserAction} from "mindsets-js-sdk";

import {isEducator} from "utils/role";

function GradeField({validation_error_messages, setValidationErrorMessages}) {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    let validation_error_messages_new = JSON.parse(JSON.stringify(validation_error_messages));

    if (isEducator(user) && user.school) {
        let user_grades;
        let items = [];
        let grade_display = 'Select grades you teach';

        if (Array.isArray(user.grades)) {
            user_grades = user.grades;
        } else {
            user_grades = [];
        }

        if (user.school.country === 'GB') {
            let uk_user_grades = [];
            let uk_user_grades_display = [];
            items = items.concat([
                {
                    id: '2-4',
                    label: 'Lower primary (2-4)'
                },
                {
                    id: '5-6',
                    label: 'Upper primary (5-6)'
                },
                {
                    id: '7-11',
                    label: 'Secondary (7-11)'
                }
            ]);
            if (user_grades.includes('2') && user_grades.includes('3') && user_grades.includes('4')) {
                uk_user_grades_display = uk_user_grades_display.concat('Lower primary (2-4)');
                uk_user_grades = uk_user_grades.concat(['2-4']);
            }
            if (user_grades.includes('5') && user_grades.includes('6')) {
                uk_user_grades_display = uk_user_grades_display.concat('Upper primary (5-6)');
                uk_user_grades = uk_user_grades.concat(['5-6']);
            }
            if (user_grades.includes('7') && user_grades.includes('8') && user_grades.includes('9') && user_grades.includes('10') && user_grades.includes('11')) {
                uk_user_grades_display = uk_user_grades_display.concat('Secondary (7-11)');
                uk_user_grades = uk_user_grades.concat(['7-11']);
            }
            if (uk_user_grades.length) {
                user_grades = uk_user_grades;
            }
            if (uk_user_grades_display.length) {
                grade_display = 'Grade ' + uk_user_grades_display.join(', ');
            }
        } else {
            items = items.concat([
                {
                    id: '2',
                    label: 'Grade 2'
                },
                {
                    id: '3',
                    label: 'Grade 3'
                },
                {
                    id: '4',
                    label: 'Grade 4'
                },
                {
                    id: '5',
                    label: 'Grade 5'
                },
                {
                    id: '6',
                    label: 'Grade 6'
                },
                {
                    id: '7',
                    label: 'Grade 7'
                },
                {
                    id: '8',
                    label: 'Grade 8'
                },
                {
                    id: '9',
                    label: 'Grade 9'
                },
                {
                    id: 'High School',
                    label: 'High School'
                }
            ]);
            if (user_grades.length) {
                grade_display = 'Grade ' + user_grades.join(', ');
            }
        }

        return (
            <div className="col s12 m6">
                <label htmlFor="grade" className="flex-row">
                    <div>Teaching grade(s) *</div>
                    {
                        validation_error_messages.hasOwnProperty('grade') ?
                            <i className="fas fa-exclamation-circle text-red ml-2"/> : null
                    }
                </label>
                <MultipleSelector
                    trigger={(
                        <div className="inputfield w100 grade-selector flex-row flex-v-center">
                            {grade_display}
                        </div>
                    )}
                    item_name='grade'
                    items={items}
                    selected={user_grades}
                    callback={selected => {
                        let user_new = JSON.parse(JSON.stringify(user));
                        if (user.school.country === 'GB') {
                            let grades = [];
                            if (selected.includes('2-4')) {
                                grades = grades.concat(['2', '3', '4']);
                            }
                            if (selected.includes('5-6')) {
                                grades = grades.concat(['5', '6']);
                            }
                            if (selected.includes('7-11')) {
                                grades = grades.concat(['7', '8', '9', '10', '11']);
                            }
                            user_new.grades = grades;
                        } else {
                            user_new.grades = selected.sort((a, b) => {
                                if (a < b) {
                                    return -1;
                                } else if (a > b) {
                                    return 1;
                                }

                                return 0;
                            });
                        }
                        dispatch(SetUserAction(user_new));
                        delete validation_error_messages_new.grade;
                        setValidationErrorMessages(validation_error_messages_new);
                    }}
                />
            </div>
        );
    }

    return null;
}

GradeField.propTypes = {
    validation_error_messages: PropTypes.object.isRequired,
    setValidationErrorMessages: PropTypes.func.isRequired
}

export default GradeField;
